import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Full-width dark call-to-action card that closes a project section. */
export function ProjectCta({
  heading,
  body,
  action,
  className,
}: {
  heading: string;
  body: string;
  action: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mt-8 flex flex-col gap-5 rounded-2xl bg-ink px-6 py-6 text-white md:flex-row md:items-center md:justify-between md:px-8 md:py-7", className)}>
      <div>
        <h3 className="font-display text-xl font-semibold tracking-tight md:text-2xl">{heading}</h3>
        <p className="mt-1.5 max-w-2xl text-sm leading-6 text-white/70 md:text-base">{body}</p>
      </div>
      <div className="shrink-0">{action}</div>
    </div>
  );
}
